import Vue from 'vue'
import store from '@/store'
import VueRouter from 'vue-router'
import rootViews from '@/views/index'
import meetingViews from '@/views/meeting/index'
import workspaceViews from '@/views/workspace/index'
import firebase from 'firebase/app'
// import { isChrome } from '@/common/lib/strLib'
// import { notify0 } from '@/common/common'

Vue.use(VueRouter)

// let notify = true
// let notifyMobile = true

const routes = [
  {
    path: '*',
    redirect: '/', // 404 페이지 셋팅 생략
    meta: {
      requiresAuth: false,
    },
  },
  // {
  //   path: '/',
  //   // redirect: '/signin',
  //   name: 'Home',
  //   component: rootViews.Home,
  //   meta: {
  //     requiresAuth: false,
  //   },
  // },
  {
    path: '/',
    name: 'Home',
    component: rootViews.Home,
    beforeEnter() {
      location.href = 'https://tape.ooo'
    },
  },
  {
    path: '/invite',
    name: 'Invite',
    component: rootViews.Invite,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/accept',
    // redirect: '/signin',
    name: 'Accept',
    component: rootViews.Accept,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: rootViews.Maintenance,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/no-access/:type',
    name: 'NoAccess',
    component: rootViews.NoAccess,
    props: true,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/payment-result',
    name: 'PaymentResult',
    component: rootViews.PaymentResult,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: rootViews.SignIn,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/chrome-extension',
    name: 'ChromeExtension',
    component: rootViews.ChromeExtension,
    meta: {
      requiresAuth: false,
    },
  },
  // Sign In / Sign Up 합쳐서 미사용 - 20221111 jsyoon
  // {
  //   path: '/signup',
  //   name: 'SignUp',
  //   component: rootViews.SignUp,
  //   meta: {
  //     requiresAuth: false,
  //   },
  // },
  {
    path: '/guest',
    name: 'GuestSignUp',
    component: rootViews.GuestSignUp,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/resetpw',
    name: 'ResetPw',
    component: rootViews.ResetPw,
    props: true,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/workspace',
    name: 'Workspace',
    component: rootViews.Workspace,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/workspace/join',
    name: 'JoinWorkspace',
    component: workspaceViews.Join,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/workspace/join/request',
    name: 'RequestWorkspace',
    component: workspaceViews.Request,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/workspace/join/complete',
    name: 'CompleteWorkspace',
    component: workspaceViews.Complete,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/workspace/create',
    name: 'CreateWorkspace',
    component: workspaceViews.Create,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/workspace/invite',
    name: 'InviteWorkspace',
    component: workspaceViews.Invite,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/:wsDomain',
    name: 'WorkspaceDomain',
    redirect: '/:wsDomain/my',
    // component: rootViews.Meeting,
    meta: {
      requiresAuth: true,
    },
  },
  // // 사용 안함 (이전 유저들을 위해 redirect)
  // {
  //   path: '/:wsDomain/meeting',
  //   name: 'Meeting',
  //   redirect: '/:wsDomain/my',
  //   // component: rootViews.Meeting,
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  // // 사용 안함 (이전 유저들을 위해 redirect)
  // {
  //   path: '/:wsDomain/meeting/inbox',
  //   name: 'MeetingListInbox',
  //   redirect: '/:wsDomain/inbox',
  //   // component: meetingViews.List,
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  // // 사용 안함 (이전 유저들을 위해 redirect)
  // {
  //   path: '/:wsDomain/meeting/private',
  //   name: 'MeetingListPrivate',
  //   redirect: '/:wsDomain/my',
  //   // component: meetingViews.List,
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  // // 사용 안함 (이전 유저들을 위해 redirect)
  // {
  //   path: '/:wsDomain/meeting/workspace',
  //   name: 'MeetingListWorkspace',
  //   redirect: '/:wsDomain/general',
  //   // component: meetingViews.List,
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  {
    path: '/:wsDomain/meeting/assigned',
    name: 'MeetingListAssigned',
    redirect: '/:wsDomain/assigned',
    // component: meetingViews.List,
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: '/:wsDomain/inbox/:chId',
  //   name: 'Inbox',
  //   component: meetingViews.List,
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  {
    path: '/:wsDomain/assigned',
    name: 'Assigned',
    component: meetingViews.List,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/:wsDomain/:chId',
    name: 'Channel',
    component: meetingViews.List,
    meta: {
      requiresAuth: true,
    },
  },
  // // 사용 안함 (이전 유저들을 위해 redirect)
  // {
  //   path: '/:wsDomain/meeting/private/:mtId',
  //   name: 'MeetingDetailPrivate',
  //   redirect: '/:wsDomain/my/:mtId',
  //   // component: meetingViews.Detail,
  //   meta: {
  //     sidebar: false,
  //     sidebarPosition: true,
  //     requiresAuth: true,
  //   },
  // },
  // // 사용 안함 (이전 유저들을 위해 redirect)
  // {
  //   path: '/:wsDomain/meeting/workspace/:mtId',
  //   name: 'MeetingDetailWorkspace',
  //   redirect: '/:wsDomain/general/:mtId',
  //   // component: meetingViews.Detail,
  //   meta: {
  //     sidebar: false,
  //     sidebarPosition: true,
  //     requiresAuth: true,
  //   },
  // },
  {
    path: '/:wsDomain/assigned/:mtId',
    name: 'ChannelMeetingAssigned',
    component: meetingViews.Detail,
    meta: {
      sidebar: false,
      sidebarPosition: true,
      requiresAuth: true,
    },
  },
  {
    path: '/:wsDomain/share/:mtId',
    name: 'ChannelMeetingShare',
    component: meetingViews.Detail,
    meta: {
      sidebar: false,
      sidebarPosition: true,
      requiresAuth: false,
    },
  },
  {
    path: '/:wsDomain/:chId/:mtId',
    name: 'ChannelMeeting',
    component: meetingViews.Detail,
    meta: {
      sidebar: false,
      sidebarPosition: true,
      requiresAuth: true,
    },
  },
  // // 사용 안함 (이전 유저들을 위해 redirect)
  // {
  //   path: '/:wsDomain/meeting/share/:mtId',
  //   name: 'PublicMeetingDetail',
  //   redirect: '/:wsDomain/share/:mtId',
  //   // component: meetingViews.Detail,
  //   props: true,
  //   meta: {
  //     sidebar: false,
  //     sidebarPosition: true,
  //     requiresAuth: false,
  //   },
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(async (to, from, next) => {
  if (to.name === 'Home') next('/signin')

  if (
    // 홈 -> 로그인 / 로그인 -> 채널 시에 전체 로딩 표시
    (from.name === 'Home' && to.name === 'SignIn') ||
    (from.name === 'SignIn' && to.name === 'Channel')
  )
    store.dispatch('setIsLoading', true)
  const currentUser = firebase.auth().currentUser

  // 로그인 상태이면서 HOME이 아닌 경우에만 처리
  if (currentUser != null && to.name !== 'Home') {
    // TODO: push notification 설정
    let deviceToken = ''

    await store.dispatch('setCurrentUser', currentUser)

    // api header Authorization 설정
    await store.dispatch('setApiHeader')

    // 회원 정보가 없는데 firebase 로그인 상태일 때만 tape 로그인 처리
    if (store.getters.userInfo == null) {
      await store.dispatch('setSignIn', {
        deviceToken: deviceToken,
      })
    }

    // 로그인한 유저는 워크스페이스에 올린 clip count 를 가져온다.
    if (to.params['wsDomain']) {
      store.dispatch('setWsClipCnt', {
        wsDomain: to.params['wsDomain'],
        userId: store.getters.userInfo ? store.getters.userInfo['userId'] : null,
      })
    }

    if (store.getters.userInfo && store.getters.userInfo !== null) {
      // 참여 워크스페이스가 없으면, 워크스페이스 생성/참여 페이지로 이동
      if (store.getters.userWsList.length === 0) await store.dispatch('getUserWsList')

      if (store.getters.signInRedirectUrl && store.getters.signInRedirectUrl !== null) {
        let signInRedirectUrl = store.getters.signInRedirectUrl
        await store.dispatch('setSignInRedirectUrl', null)
        router.push(signInRedirectUrl).catch(() => {})
      }
    }
  }

  // 이메일 세팅값 저장
  if (to.query && to.query.pref && to.query.pref !== '') await store.dispatch('setOpenPref', to.query.pref)

  let requiresAuth = to.matched.some((record) => record.meta.requiresAuth)

  // 점검 중이 아닐 때는 점검 중 페이지 접근 X
  if (to.name === 'Maintenance') next('/')
  else if (to.name === 'Home' || to.name === 'Accept' || to.name === 'NoAccess' || to.name === 'PaymentResult') {
    next()
  }
  // Public 으로 들어온 url 체크하기
  else if (
    to.name.indexOf('MeetingDetail') > -1 ||
    to.name.indexOf('ChannelMeeting') > -1
    // to.path.includes('share')
  ) {
    await store.dispatch('chkMtPublic', to.params.mtId)
    requiresAuth = !store.getters.chkMtPublic['isPublic']
  } else if (to.name.indexOf('Channel') > -1) {
    // if (to.params['chId'] && to.params['chId'] !== 'my' && to.params['chId'] !== 'general' && !from.name) {
    if (to.params['chId'] && to.params['chId'] !== 'my' && to.params['chId'] !== 'general' && !from.name) {
      await store.dispatch('chkChPublic', {
        wsDomain: to.params.wsDomain,
        chId: to.params.chId,
      })
    }
    requiresAuth = false
  } else if (to.name !== 'SignIn' && to.name !== 'SignUp' && to.name !== 'GuestSignUp') {
    store.commit('chkMtPublic', { isPublic: false })
    let params = store.getters.chkChPublic
    if (params) params['isPublic'] = false
    else params = { isPublic: false }
    store.commit('chkChPublic', params)
  }
  if (
    to.name !== 'Home' &&
    // to.name !== 'SignIn' &&
    // to.name !== 'SignUp' &&
    to.name !== 'GuestSignUp' &&
    from.name !== 'GuestSignUp' &&
    to.name !== 'MyMeetingDetail' &&
    to.name !== 'Channel' &&
    to.name !== 'ChannelMeeting' &&
    to.name !== 'ChannelMeetingShare' &&
    to.name !== 'Inbox' &&
    to.name !== 'NoAccess' &&
    store.getters.userInfo &&
    store.getters.userInfo.userStatus === 'G'
  ) {
    next('/guest')
  }
  // 접근 권한 없이 접근 권한 필요 페이지에 접근 할 경우
  else if (requiresAuth && !currentUser) {
    next('/signin')
  }
  // 로그인 안한 유저가 Channel 접근 시
  else if (!currentUser && to.name === 'Channel') {
    // if (!store.getters.chkChPublic || (store.getters.chkChPublic && !store.getters.chkChPublic['isInbox']))
    if (!store.getters.chkChPublic || (store.getters.chkChPublic && !store.getters.chkChPublic['isPublic']))
      next('/signin')
    // next({ path: '/no-access/workspace', query: { wsDomain: to.params.wsDomain } })
    // 채널이 공개되어 있지 않다면
    else if (
      store.getters.chkChPublic &&
      // store.getters.chkChPublic['isInbox'] &&
      !store.getters.chkChPublic['isPublic']
    ) {
      next({ path: '/no-access/channel' })
    }
    // 채널이 공개되어 있다면
    else {
      // 단일 채널을 조회해서 넣어준다.
      if (!store.getters.selectedCh || !store.getters.selectedCh['chId'] || store.getters.selectedCh['chId'] === 'my')
        await store.dispatch('getChannel', to.params['chId'])
      next()
    }
  }
  // 접근 권한이 있을 경우
  else {
    // * 미팅 (비디오) 링크를 통해 접속한 경우
    // TODO: 해당 미팅, 비디오에 접근 권한이 있는지 체크
    // TODO: 해당 미팅 (비디오)로 이동
    if (
      !currentUser &&
      !store.getters.chkMtPublic['isPublic'] &&
      to.name !== 'SignIn' &&
      to.name !== 'SignUp' &&
      to.name !== 'Home' &&
      to.name !== 'Invite' &&
      to.name !== 'Accept' &&
      to.name !== 'GuestSignUp' &&
      to.name !== 'NoAccess' &&
      to.name !== 'PaymentResult' &&
      to.name !== 'Channel' &&
      to.name !== 'ChromeExtension'
    ) {
      next('/signin')
    }
    // 회원이고, 게스트로그인이 아니면
    else if (currentUser) {
      if (to.params['selectCh']) await store.dispatch('setSelectedCh', to.params['selectCh'])
      // 회원이여도 홈은 그냥 진행
      if (
        to.name === 'Home' ||
        to.name === 'Accept' ||
        to.name === 'InviteWorkspace' ||
        to.name === 'CompleteWorkspace' ||
        to.name === 'Invite' ||
        to.name === 'PaymentResult' ||
        to.name === 'NoAccess' ||
        to.name === 'ChromeExtension'
      ) {
        next()
      }
      // 로그인/가입 페이지 접근 시
      else if (to.name === 'SignIn' || to.name === 'SignUp') {
        // 참여 워크스페이스가 있으면, 미팅 리스트로 이동
        if (store.getters.userInfo && store.getters.userWsList.length > 0) {
          setSelectedWs(to.params.wsDomain, next, true, to.params)
        }
        // 게스트 로그인에 권한없는 페이지 접근할 시 접근 제어
        else if (store.getters.userInfo && store.getters.userInfo.userStatus === 'G') {
          next()
        }
        // 참여 워크스페이스가 없으면, 워크스페이스 생성/참여 페이지로 이동
        else next('/workspace')
      } else if (
        to.name === 'Workspace' ||
        to.name === 'CreateWorkspace' ||
        to.name === 'JoinWorkspace' ||
        to.name === 'RequestWorkspace'
      ) {
        // Workspace 가 있을경우 화면과 JoinOrCreate 일 경우 분기 처리를 해주기 위해 사용
        if (to.name === 'Workspace') await store.dispatch('setIsJoinOrCreate', to.params.isJoinOrCreate)

        if (store.getters.isJoinOrCreate) next()
        // 참여 워크스페이스가 있으면, 미팅 리스트로 이동
        else if (store.getters.userInfo && store.getters.userWsList.length > 0) {
          setSelectedWs(to.params.wsDomain, next, true, to.params)
        }
        // 참여 워크스페이스가 없으면, 워크스페이스 관련 페이지로 계속 이동
        else {
          next()
        }
      } else {
        if (
          (store.getters.chkMtPublic['isPublic'] &&
            (to.name.indexOf('MeetingDetail') > -1 || to.name.indexOf('ChannelMeeting') > -1)) ||
          (store.getters.chkChPublic && to.name.indexOf('Channel') > -1)
        ) {
          if (store.getters.userInfo && store.getters.userWsList.length > 0) {
            setSelectedWs(to.params.wsDomain, next, false, to.params)
          } else {
            if (
              to.params &&
              to.params['chId'] &&
              (!store.getters.selectedCh || !store.getters.selectedCh['chCategory'])
            ) {
              if (
                !store.getters.selectedCh ||
                !store.getters.selectedCh['chId'] ||
                store.getters.selectedCh['chId'] === 'my'
              )
                await store.dispatch('getChannel', to.params['chId'])
            }
            next()
          }
          // next()
        } else {
          // if (localStorage.getItem('magicLinkCode') !== null) next('/invite')
          // else {
          // 참여 워크스페이스가 있으면, 미팅 관련 페이지로 계속 이동
          if (store.getters.userWsList.length > 0) {
            setSelectedWs(to.params.wsDomain, next, false, to.params)
          }
          // 게스트 로그인에 권한없는 페이지 접근할 시 접근 제어
          else if (store.getters.userInfo && store.getters.userInfo.userStatus === 'G') {
            if (
              (to.name === 'MyMeetingDetail' && !store.getters.chkMtPublic['isPublic']) ||
              (to.name === 'Channel' && !store.getters.chkChPublic)
            ) {
              next({ path: '/no-access/workspace', query: {} })
            } else next()
          }
          // 참여 워크스페이스가 없으면, 워크스페이스 생성/참여 페이지로 이동
          else {
            next('/workspace')
          }
          // }
          // 게스트 로그인에 권한없는 페이지 접근할 시 접근 제어
          // else if (store.getters.userInfo && store.getters.userInfo.userStatus === 'G') {
          //   if (to.name === 'MyMeetingDetail' && !store.getters.chkMtPublic) {
          //     next({ path: '/no-access/workspace', query: {} })
          //   } else next()
          // }
          // 참여 워크스페이스가 없으면, 워크스페이스 생성/참여 페이지로 이동
          // else {
          //   next('/workspace')
          // }
          // }
        }
      }
    } else {
      next()
    }
  }
  store.dispatch('setIsLoading', false)
})

// 워크스페이스 도메인 접속 처리
let setSelectedWs = async (wsDomain, next, isGoToMt, routeParams) => {
  // 주소에 워크스페이스 도메인이 없으면, 첫번째 워크스페이스로 자동 이동
  if (!wsDomain) {
    if (isGoToMt) next()

    let lastSelectedWsInfo
    let parsedWsInfo

    try {
      lastSelectedWsInfo = localStorage.getItem('lastSelectedWsInfo')
      if (lastSelectedWsInfo !== undefined && lastSelectedWsInfo !== null) parsedWsInfo = JSON.parse(lastSelectedWsInfo)
    } catch (e) {
      console.log()
    }

    let storageWs = parsedWsInfo !== undefined && parsedWsInfo !== null ? parsedWsInfo : null
    if (storageWs && storageWs !== 'null') {
      next(`/${storageWs.wsDomain}/my`)
    } else {
      next(`/${store.getters.userWsList[0].wsDomain}/my`)
    }
  } else {
    // 주소에 워크스페이스 도메인이 있으면, 해당 회원의 참여 워크스페이스 목록에서 찾기
    let selectedWs
    if (store.getters.userWsList !== undefined && store.getters.userWsList !== null) {
      selectedWs = store.getters.userWsList.find((ws) => ws.wsDomain === wsDomain)
    }
    // 미팅이 Public 이거나, 미팅 생성자가 현재 유저일 경우 체크 권한 해제
    let isMtCreator =
      store.getters.userInfo &&
      store.getters.chkMtPublic &&
      store.getters.userInfo['userId'] === store.getters.chkMtPublic['mtCreatedUid']

    // 선택된 워크스페이스가 없고, inbox 채널일 경우
    if (!selectedWs && store.getters.chkChPublic) {
      // 인박스 채널로 접속한 경우
      // if (store.getters.chkChPublic && store.getters.chkChPublic['isInbox']) {
      if (store.getters.chkChPublic) {
        // 채널이 공개되어 있지 않은 경우
        if (!store.getters.chkChPublic['isPublic']) {
          next({ path: '/no-access/channel' })
        } else {
          if (
            !store.getters.selectedCh ||
            !store.getters.selectedCh['chId'] ||
            store.getters.selectedCh['chId'] === 'my'
          ) {
            await store.dispatch('getChannel', routeParams['chId'])
          }
          next()
        }
      } else {
        next({ path: '/no-access/workspace', query: { wsDomain: wsDomain } })
      }
    }

    // 선택된 워크스페이스가 없고, Inbox 정보도 없고, Public 미팅도 없을 경우
    else if (!selectedWs && !store.getters.chkChPublic && !store.getters.chkMtPublic['isPublic'] && !isMtCreator) {
      next({ path: '/no-access/workspace', query: { wsDomain: wsDomain } })
    }
    // 목록에 존재하면 선택된 워크스페이스로 지정하고 이동
    else {
      // 워크스페이스 선택 지정
      // [202207 추가] 만약 선택된 워크스페이스가 없거나 이전 선택된 워크스페이스와 현재 선택한 워크스페이스가 다를 때만 워크스페이스 재지정
      if (
        !store.getters.selectedWsInfo ||
        (store.getters.selectedWsInfo && store.getters.selectedWsInfo['wsId'] !== selectedWs['wsId'])
      ) {
        if (selectedWs) {
          if (routeParams && routeParams['chId']) selectedWs['routeParams'] = routeParams
          await store.dispatch('setSelectedWsInfo', selectedWs)
        } else if (routeParams && routeParams['chId']) {
          if (
            !store.getters.selectedCh ||
            !store.getters.selectedCh['chId'] ||
            store.getters.selectedCh['chId'] === 'my'
          )
            await store.dispatch('getChannel', routeParams['chId'])
          next()
        }
      }
      // 미팅 페이지로 강제로 보낼지, 가고자 하는 페이지로 계속 이동시킬지 처리
      if (isGoToMt) {
        next(`${wsDomain}/my`)
      } else next()
    }
  }
}

export default router
